<template>
  <div
      :style="isPC
      ? 'padding: 9.375rem 2.5vw 1.5rem; overflow-x: hidden'
      : 'padding: 11.375rem 2.5vw 1.5rem; overflow-x: hidden'
    "
  >
    <div class="homework-box">
      <div class="search-box">
        <el-row type="flex" align="bottom" :gutter="20" style="flex-wrap: wrap">
          <el-col :sm="6" :xs="24" :lg="6">
            <div class="input-title">{{ $t("studentProgramme.startDate") }}</div>
            <el-date-picker
                align="center"
                v-model="form.startDate"
                type="date"
                placeholder="DD/MM/YY"
                format="dd/MM/yyyy"
                clearable
                style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :sm="6" :xs="24" :lg="6">
            <div class="input-title">{{ $t("studentProgramme.endDate") }}</div>
            <el-date-picker
                align="center"
                v-model="form.endDate"
                type="date"
                placeholder="DD/MM/YY"
                format="dd/MM/yyyy"
                clearable
                style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :xs="24" :sm="6" :lg="6" style="padding-top: 0.625rem">
            <div class="input-title">{{ $t("studentProgramme.search") }}</div>
            <el-input
                class="search"
                :placeholder="$t('studentProgramme.searchForExamKeywords')"
                v-model="form.name"
                prefix-icon="el-icon-search"
            ></el-input>
          </el-col>
          <el-col
              :lg="{ span: 5, offset: 1 }"
              :xs="24"
              :sm="6"
              style="display: flex; padding-top: 0.625rem"
          >
            <button
                @click="search"
                class="security-button cursor-pointer"
                style="background-color: #fcc03a; margin-right: 1rem; flex: 3"
            >
              {{ $t("studentProgramme.search") }}
            </button>
          </el-col>
        </el-row>
      </div>

      <div class="summary-box">
        <!-- PC端表格 -->
        <el-table :data="tableData" style="width: 100%" v-if="isPC">
          <el-table-column prop="name" :label="$t('studentProgramme.homework')">
            <template slot-scope="{ row }">
              <div>{{ row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              prop="startDate"
              :label="$t('studentProgramme.startDate')"
              :formatter="startFormatter"
          >
          </el-table-column>
          <el-table-column
              align="center"
              prop="endDate"
              :label="$t('studentProgramme.endDate')"
              :formatter="endFormatter"
          >
          </el-table-column>
          <el-table-column
              align="center"
              prop="completedAt"
              :label="$t('studentProgramme.finishDate')"
              :formatter="completedAtFormatter"
          >
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.score')" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.completedAt">
                {{ row.correctQuantity + "/" + row.totalQuantity }}
              </span>
              <span v-else>-/-</span>
            </template>
          </el-table-column>
          <el-table-column align="center" v-if="tableData.length > 0">
            <template slot-scope="scope">
              <el-button
                  size="small" type="danger"
                  v-if="needHomework(scope.row)"
                  @click="toExamination(scope.row.id, gradeId)"
              >
                {{ $t("studentProgramme.doHomeWork") }}
              </el-button>
              <el-button
                  v-if="scope.row.completedAt != null"
                  @click="handleReview(scope.row)"
              >
                {{ $t("studentProgramme.review") }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column width="40" v-else></el-table-column>
        </el-table>

        <!-- 移动端卡片布局 -->
        <div class="mobile-homework-list" v-else>
          <div class="homework-card" v-for="(row, index) in tableData" :key="index">
            <div class="card-header">
              <h3 class="homework-number">{{ row.name }}</h3>
            </div>

            <div class="card-body">
              <div class="info-item">
                <span class="info-label">{{ $t("studentProgramme.startDate") }}：</span>
                <span class="info-value">{{ startFormatter(row) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">{{ $t("studentProgramme.endDate") }}：</span>
                <span class="info-value">{{ endFormatter(row) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">{{ $t("studentProgramme.finishDate") }}：</span>
                <span class="info-value">{{ completedAtFormatter(row) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">{{ $t("studentProgramme.score") }}：</span>
                <span class="info-value">
                  <span v-if="row.completedAt">{{ row.correctQuantity + "/" + row.totalQuantity }}</span>
                  <span v-else>-/-</span>
                </span>
              </div>
            </div>

            <div class="card-footer">
              <el-button
                  v-if="needHomework(row)"
                  size="small" type="danger"
                  class="mobile-btn do-homework"
                  @click="toExamination(row.id, gradeId)"
              >
                {{ $t("studentProgramme.doHomeWork") }}
              </el-button>
              <el-button
                  v-if="row.completedAt != null"
                  class="mobile-btn review"
                  @click="handleReview(row)"
              >
                {{ $t("studentProgramme.review") }}
              </el-button>
            </div>
          </div>
        </div>

        <!-- 分页组件 -->
        <Pagination
            v-show="total > 0"
            :small="$store.getters.isPC ? false : true"
            :total="total"
            :autoScroll="false"
            :page.sync="listQ._page"
            :limit.sync="listQ._limit"
            @pagination="getData"
            layout="pager"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeworks } from "@/api/homework";
import Pagination from "@/components/Pagination";
import { formatDateTime, formatDate2 } from "@/filters";
import { isPC } from "@/utils/is-rules.js";
import moment from "moment";
import { getUserInfo } from "@/utils/auth";

export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Pagination },
  name: "home",
  data() {
    return {
      isPC: isPC(),
      total: 0,
      gradeId: null,
      form: {
        studentId: null,
        gradeId: null,
        startDate: null,
        endDate: null,
        keywords: null,
        name: null,
      },
      listQ: {
        _page: 1,
        _limit: 20,
      },
      tableData: [],
    };
  },
  watch: {
    "$store.getters.currentGradeId": {
      handler(v) {
        this.gradeId = v;
        this.getData();
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getData();
    this.gradeId = this.$store.getters.currentGradeId;
  },
  methods: {
    // 跳转到答题页面
    toExamination(id, gradeId) {
      this.$router.push({
        path: "/examination",
        query: {
          type: "work",
          id: id,
          gradeId: gradeId,
          startTime: moment().format("YYYY-MM-DD HH:mm:ss")
        },
      });
    },
    handleReview(row) {
      const answerResult = row.answerResult || {}
      this.$router.push({
        path: "/examinationAnswerResult",
        query: {
          objectName: row.number,
          type: "library",
          topicId: answerResult.topicId,
          id: answerResult.objectId,
          answerResultId: answerResult.id,
          questionListIds: answerResult.questionListIds,
          answerValues: answerResult.answerValues
        },
      });
    },
    getStartTime() {
      return moment().format("YYYY-MM-DD HH:mm:ss");
    },
    // 获取作业列表数据
    getData() {
      let form = {
        studentId: this.form.studentId,
        gradeId: this.form.gradeId || this.gradeId,
        type: 1,
        startDate: formatDate2(this.form.startDate),
        endDate: formatDate2(this.form.endDate),
        keywords: this.form.keywords,
        name: this.form.name,
        _page: this.listQ._page - 1,
        _limit: this.listQ._limit,
      };
      getHomeworks(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    // 日期格式化
    startFormatter(row) {
      return formatDateTime(row.startDate) || "---";
    },
    endFormatter(row) {
      return formatDateTime(row.endDate) || "---";
    },
    completedAtFormatter(row) {
      return formatDateTime(row.completedAt) || "---";
    },
    // 搜索
    search() {
      this.getData();
    },
    // 清空筛选
    clearSearch() {
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.keywords = "";
      let form = {
        studentId: this.form.studentId,
        gradeId: this.form.gradeId || this.gradeId,
        _page: 0,
        _limit: this.listQ._limit,
        lang: getUserInfo("userProfile").studying,
      };
      getHomeworks(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    // 判断是否需要做作业
    needHomework(row) {
      if (row.completedAt) return false;
      else if (row.startDate && row.endDate) {
        return this.$options.filters["isBetween2"](
            new Date(),
            row.startDate,
            row.endDate
        );
      } else if (!row.endDate) return true;
      else return false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 定义响应式断点
$minWidth: 768px;
$maxWidth: 991px;
$phoneMinWidth: 320px;
$phoneMaxWidth: 767px;

.homework-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 6.25vw;
  background: #ffffff;
  border-radius: 2.5rem;
}
.model-box {
  display: flex;
  text-align: center;
  background: white;
  border: 1px #b62d2e solid;
  border-radius: 2rem;
  padding: 0.25rem;
  margin: 1rem;
}
.model-move {
  position: absolute;
  transition: transform 0.4s linear 0s;
  transform: translateX(0%);
  width: 5rem;
  height: 2rem;
  border-radius: 1rem;
  mix-blend-mode: difference;
  background: #00ffff;
}
.model-text {
  line-height: 2rem;
  width: 5rem;
  color: #ff0000;
}
.input-title {
  color: #8e8e8e;
  font-weight: 500;
  line-height: 1.6rem;
  font-family: "GenSenRoundedJP", "Helvetica", "Arial";
}
.security-button {
  border: 0.0625rem solid #fcc03a;
  background-color: #ffffff;
  font-weight: bold;
  font-size: 1rem;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 2.625rem;
  height: 2.75rem;
}
.search-box {
  font-size: 0.875rem;
  width: 100%;
}
.summary-box {
  width: 100%;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.table-button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.5rem;
  line-height: 2rem;
  display: block;
  margin: 0 auto 0.5rem;
  padding: 0.5rem 2rem;
}

// 移动端卡片样式
.mobile-homework-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 1.5rem;
}
.homework-card {
  background: #fff;
  border-radius: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f5f5f5;
  overflow: hidden;
}
.card-header {
  background: #fceedd;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #fee8c8;
  .homework-number {
    font-size: 1.1rem;
    font-weight: 600;
    color: #444;
    margin: 0;
    line-height: 1.4;
  }
}
.card-body {
  padding: 1.2rem 1.5rem;
  .info-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.75rem;
    font-size: 0.95rem;
    &:last-child {
      margin-bottom: 0;
    }
    .info-label {
      color: #8e8e8e;
      min-width: 70px;
      flex-shrink: 0;
      line-height: 1.4;
    }
    .info-value {
      color: #444;
      flex: 1;
      word-break: break-all;
      line-height: 1.4;
    }
  }
}
.card-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.mobile-btn {
  border: none;
  border-radius: 2.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  color: #444;
  cursor: pointer;
  transition: all 0.2s ease;
  &.do-homework {
    background: #fcc03a;
    box-shadow: 0px 0.3rem 0 #c28c00;
  }
  &.review {
    background: #fcc03a;
    border: 1px solid #c28c00;
  }
  &:active {
    transform: translateY(2px);
    box-shadow: none;
  }
}
.empty-tip {
  text-align: center;
  padding: 3rem 0;
  color: #999;
  font-size: 1rem;
}

/* 平板适配 */
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    font-size: 1.25rem;
    line-height: 1.5rem;
    padding: 0.375rem 1.5rem;
  }
}
/* 手机适配 */
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    font-size: 1.25rem;
    line-height: 1.5rem;
    padding: 0.375rem 1.5rem;
  }
}

::v-deep {
  .ellipsis-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-select .el-input .el-select__caret {
    color: #b62d2e;
  }
  .el-input__prefix {
    color: #b62d2e;
  }
  .el-date-editor {
    .el-input__prefix {
      left: auto;
      right: 5px;
    }
    .el-input__suffix {
      color: #444444;
      right: 25px;
    }
  }
  .el-input__inner {
    border-radius: 0.625rem;
    border: 0.0625rem solid #8e8e8e;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .search .el-input__inner {
    padding-left: 30px;
  }
  .el-icon-search {
    background: url("~@/assets/images/search2.png") center center/contain no-repeat;
  }
  .el-icon-search:before {
    content: "";
  }
  .el-table {
    font-size: 1rem;
  }
  .el-table .cell {
    padding: 0;
    line-height: 3.5rem;
  }
  .el-table th.el-table__cell > .cell {
    padding: 0;
  }
  .el-table th {
    background: #fceedd;
    color: #444444;
  }
  .el-table th:first-child {
    padding-left: 3rem;
  }
  .el-table td:first-child {
    padding-left: 3rem;
  }
}
</style>